import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sparkles, Calendar } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

const heroImg = '/hero-salon.jpg';

export default function HeroSection() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <section className="relative overflow-hidden min-h-[75vh] flex items-center">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={heroImg}
          alt="Bonjour Sobrancelhas Salon"
          className="w-full h-full object-cover"
          fetchPriority="high"
          loading="eager"
          decoding="async"
          width={1920}
          height={1080}
          sizes="100vw"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background/90 via-background/70 to-background/40" />
      </div>

      <div className="container mx-auto px-4 py-20 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-xl"
        >
          <div className="inline-flex items-center gap-2 bg-primary/10 backdrop-blur-sm text-primary rounded-full px-4 py-1.5 text-sm font-medium mb-6">
            <Sparkles className="h-4 w-4" />
            Realce sua beleza natural
          </div>


          <div className="mb-6">
            <h1 className="font-display text-4xl md:text-6xl font-bold text-foreground leading-tight">
              Bonjour
              <span className="text-primary block">Sobrancelhas</span>
            </h1>
          </div>


          <p className="text-muted-foreground text-lg md:text-xl mb-10 font-light leading-relaxed">
            Especialista em nanopigmentação e design de sobrancelhas.
            Realce a sua beleza com técnicas delicadas, personalizadas e com total naturalidade.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Button variant="hero" size="xl" onClick={() => navigate('/booking')}>
              <Calendar className="h-5 w-5" />
              Agendar Horário
            </Button>
            {!user && (
              <Button variant="outline-hero" size="xl" onClick={() => navigate('/auth?tab=signup')}>
                Criar Conta
              </Button>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
